import { hd } from '@nx-fe/services';
import { BaseMessage } from '../messages';
import {
    KillAndroidProcessMessage,
    KillWindowsProcessMessage,
    TaskDetailsAndroidMessage,
    TaskListWindowsMessage,
    ThreadTimesWindowsMessage,
    TaskDetailsWindowsMessage,
    ITaskDetailsAndroid,
} from '../messages/pocket-com';
import { AndroidActivityManagement, TaskError, TaskMemoryUsage, TaskModule, TaskPackage, TaskThread } from 'app/modules/remote-control-ng/definitions';
import { Session } from '../session';
import { RcContext } from '../context/rcContext';
import { take, takeUntil } from 'rxjs/operators';
import { SubscriptionCleaner } from './subscriptionCleaner';
import { Injectable } from '@angular/core';

type tmCallback = (data: hd.IRcTask[]) => void;
type tdCallbackAndroid = (tasks: TaskPackage[], mem: TaskMemoryUsage, err: TaskError) => void;
type tdCallbackWin = (threads: TaskThread[], modules: TaskModule[]) => void;


// Very light service that connects the RC services to the task messaging
// in the RC engine with callbacks
@Injectable({providedIn: "root"})
export class TaskManagerProxyService extends SubscriptionCleaner {
    private _threadTimesCallback: () => void;

    constructor() {
        super();
    }

    public getTaskList(isWindows: boolean, callback: tmCallback): void {
        const options: ITaskDetailsAndroid = {
            messageType: AndroidActivityManagement.AAM_GET_PROCESSES_LIST
        };
        const message: BaseMessage = isWindows ? new TaskListWindowsMessage() : new TaskDetailsAndroidMessage(options);
        RcContext.instance.session.sendRequest(message).pipe(take(1), takeUntil(this.isDestroyed$)).subscribe(
            (reply: BaseMessage) => {
                const data = isWindows ? (<TaskListWindowsMessage>reply)?.response : (<TaskDetailsAndroidMessage>reply)?.responseTasks;
                callback(data);
            },
            () => {
                // Handle any error that occurs during the reply
            });
    }

    public getTaskDetails(isWindows: boolean, pid: number, callback: tdCallbackAndroid | tdCallbackWin): void {
        const options: ITaskDetailsAndroid = {
            pid: pid,
            messageType: AndroidActivityManagement.AAM_GET_PROCESS_DETAILS
        };
        const message = isWindows ? new TaskDetailsWindowsMessage(pid) : new TaskDetailsAndroidMessage(options);
        RcContext.instance.session.sendRequest(message).subscribe(
            (reply: TaskDetailsAndroidMessage | TaskDetailsWindowsMessage) => {
                if (isWindows) {
                    const wcallback = (<tdCallbackWin>callback);
                    const wresp = (<TaskDetailsWindowsMessage>reply).response;
                    wcallback(wresp.threads, wresp.modules);
                } else {
                    const acallback = (<tdCallbackAndroid>callback);
                    const aresp = (<TaskDetailsAndroidMessage>reply).responseDetails;
                    acallback(aresp.tasks, aresp.mem, aresp.err);
                }
            }, (error) => {
                // Handle any error that occurs during the reply
            });
    }

    public sendKillWindowsProcess(pid: number): void {
        const message = new KillWindowsProcessMessage(pid);
        RcContext.instance.session.sendMessage(message);
    }

    public sendKillAndroidProcess(pid: number): void {
        const message = new KillAndroidProcessMessage(pid);
        RcContext.instance.session.sendMessage(message);
    }

    /**
     * @deprecated The method should not be used, use task commands and RequestReplyService instead
     */
    public getThreadTimesList(): number {
        const message = new ThreadTimesWindowsMessage();
        return RcContext.instance.session.sendCallbackRequest(message, this._threadTimesCallback);
    }

    /**
     * @deprecated The method should not be used, use task commands and RequestReplyService instead
     */
    public setThreadTimesWindowsCallback(callback: any): void {
        this._threadTimesCallback = callback;
    }
}